import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}
interface QueryPagoFacturaWeb {
  rut: string | undefined;
  clasificacionDocumento: string | undefined;
}

export const tieneDiasCredito = async (
  query: QueryPagoFacturaWeb
): Promise<boolean> => {
  try {
    const res = await apiClient.post<ApiResponse<boolean>>(
      Endpoints.TieneDiasCredito,
      {
        rut: query.rut,
        clasificacionDocumento: query.clasificacionDocumento,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
